import { ArticleSection } from "@/types/articleEntryData.types";
import { EntryDataValueInfo } from "@/types/drugProfile.types";
import { IS_NOT_EDITABLE_SHELL_KEYS } from "@FillInTableContainer/components/FillInTable/constants/disabledShellBySection.constants";

type Props = {
  articleSection: ArticleSection;
  fieldKey: string;
  currentValue: [] | EntryDataValueInfo[];
  defaultClearValue?: [] | EntryDataValueInfo[];
};

export const getConditionalClearValue = ({
  articleSection,
  fieldKey,
  currentValue,
  defaultClearValue = [],
}: Props): [] | EntryDataValueInfo[] => {
  const isNotEditable =
    IS_NOT_EDITABLE_SHELL_KEYS[articleSection].includes(fieldKey);

  return isNotEditable ? currentValue || [] : defaultClearValue;
};
